import { Product } from './Product'
import { SKU } from './SKU'

export class Modifier extends Product {
    constructor(
        id: string,
        displayName: string,
        description: string | null,
        skus: SKU[],
        dateCreated: Date,
        dateUpdated: Date
    ) {
        super(id, displayName, description, skus, dateCreated, dateUpdated)
    }
}

export class ModifierGroup {
    constructor(
        public id: string,
        public name: string,
        public minimumModifiersRequired: number | null,
        public maximumModifiersRequired: number | null,
        public modifiers: Modifier[],
        public dateCreated: Date,
        public dateUpdated: Date
    ) {}
}
